
export default {
  allSettings: (state) => state.settings,
  settingsLoading: (state) => state.settingsLoading
}
